<template>
  <div id="app">
    <b-navbar type="is-light">
      <template slot="brand">
        <b-navbar-item>
          <router-link :to="{path: '/'}">
            <p class="title">GW2 Scratch</p>
          </router-link>
        </b-navbar-item>
      </template>
      <template slot="start">
        <b-navbar-item tag="router-link" :to="{path: '/'}">
          Home
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{path: '/calculators'}">
          Calculators
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{path: '/guides/raids'}" v-if="testSectionsShown">
          Raid Guides
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{path: '/tools'}">
          Tools
        </b-navbar-item>
        <b-navbar-dropdown label="Database" v-if="databaseItemsShown || databaseRecipesShown">
          <b-navbar-item tag="router-link" :to="{path: '/database/items'}" v-if="databaseItemsShown">
            Items
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{path: '/database/recipes'}" v-if="databaseRecipesShown">
            Recipes
          </b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-dropdown label="Shinies" v-if="shiniesRecipesShown">
          <b-navbar-item tag="router-link" :to="{path: '/shinies/recipes'}" v-if="shiniesRecipesShown">
            Recipes
          </b-navbar-item>
          <!--
          <b-navbar-item tag="router-link" :to="{path: '/shinies/recipes/crafting'}">
            Crafting calculator
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{path: '/shinies/recipes/items'}">
            Item profits
          </b-navbar-item>
          -->
        </b-navbar-dropdown>
        <b-navbar-dropdown label="Economics" v-if="economicsRecipesShown">
          <b-navbar-item tag="router-link" :to="{path: '/economics/recipes'}" v-if="economicsRecipesShown">
            Recipes
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{path: '/economics/usage'}" v-if="economicsUsageShown">
            Item usage
          </b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-dropdown label="Tests" v-if="testSectionsShown">
          <b-navbar-item tag="router-link" :to="{path: '/component-test'}">
            Component test
          </b-navbar-item>
          <b-navbar-item tag="router-link" :to="{path: '/acquisition'}">
            Acquisition
          </b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-item tag="router-link" :to="{path: '/discord'}">
          Discord
        </b-navbar-item>
      </template>
      <template slot="end">
        <b-navbar-item tag="router-link" :to="{path: '/users'}" v-if="userManagementShown">
          Users
        </b-navbar-item>
        <b-navbar-item tag="router-link" :to="{path: '/options'}">
          Options
        </b-navbar-item>
      </template>
    </b-navbar>
    <section id="main-section" class="section">
      <router-view/>
    </section>
    <footer class="footer">
      <div class="container content">
        <p class="has-text-centered">
        Contact us at skritt@gw2scratch.com or on our <router-link to="/discord">Discord</router-link> server.
        </p>
        <!--
        <br>
        <br>
        <p>
          This unofficial website uses art and screenshots from Guild Wars 2 and the official Guild Wars 2 API.
          ©2010–2020 ArenaNet, LLC. All rights reserved. Guild Wars, Guild Wars 2, Heart of Thorns, Guild Wars 2: Path of
          Fire, ArenaNet, NCSOFT, the Interlocking NC Logo, and all associated logos and designs are trademarks or
          registered trademarks of NCSOFT Corporation. All other trademarks are the property of their respective owners.
        </p>
        -->
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    computed: {
      testSectionsShown() {
        return this.$store.state.options.passwordEntered;
      },
      userManagementShown() {
        return this.$store.state.permissions.permissions.includes("UserManagement");
      },
      databaseItemsShown() {
        return this.$store.state.permissions.permissions.includes("DatabaseItems");
      },
      databaseRecipesShown() {
        return this.$store.state.permissions.permissions.includes("DatabaseRecipes");
      },
      shiniesRecipesShown() {
        return this.$store.state.permissions.permissions.includes("ShiniesRecipesListInstantBuy")
                || this.$store.state.permissions.permissions.includes("ShiniesRecipesListBuyOrder");
      },
      economicsRecipesShown() {
        return this.$store.state.permissions.permissions.includes("EconomicsAcquisitions")
      },
      economicsUsageShown() {
        return this.$store.state.permissions.permissions.includes("EconomicsItemUsage")
      },
    }
  }
</script>

<style>
  /* Make sure the footer is the bottom of the page even if there isn't enough content */
  #app {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }
  #main-section {
    flex: 1;
  }
</style>
